import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { Guide } from './types';

export type SaveGuideRequest = {
   guideid: number;
   revisionid: number;
   fields: Partial<Guide>;
   common: CommonRequestOptions;
};

export async function saveGuide({
   guideid,
   revisionid,
   fields,
   common = {},
}: SaveGuideRequest): Promise<Guide> {
   return makeRequest('patch', `guides/${guideid}`, {
      ...common,
      query: {
         revisionid,
      },
      body: fields,
   });
}
